import Header from "./components/Header";
import VideoSection from "./components/VideoSection";
import OpeningText from "./components/OpeningText";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-stone-950 text-stone-100">
      {/* Background image with overlay */}
      <div className="fixed inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20rock%20bar%20interior%20with%20warm%20amber%20lighting%2C%20bearded%20men%20in%20leather%20jackets%20and%20elegant%20smiling%20women%20in%20evening%20dresses%20enjoying%20whiskey%20and%20cigars%2C%20moody%20atmosphere%20with%20soft%20golden%20light%2C%20rustic%20wooden%20furniture%2C%20vintage%20rock%20posters%2C%20smoke%20and%20ice%20cubes%20in%20whiskey%20glasses%2C%20cinematic%20composition%20with%20deep%20shadows%20and%20rich%20warm%20tones%2C%20professional%20photography%20style&width=1920&height=1080&seq=jack-house-hero-01&orientation=landscape"
          alt="Jack's House Rock Bar background"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-stone-950/80" />
      </div>

      <div className="relative z-10 pt-32 md:pt-40">
        <Header />
        <VideoSection />
        <OpeningText />
        <Footer />
      </div>
    </main>
  );
}